import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  const headerScrollChangeAt = 20;

  useEffect(() => {
    window.addEventListener("scroll", isScrolled);
    return () => {
      window.removeEventListener("scroll", isScrolled);
    };
  });

  /* Method that will fix header after a specific scrollable */
  const isScrolled = (event) => {
    const headerLogo = document.querySelector(".header-logo");
    const scrollTop = window.scrollY;
    const mediumPlus = window.innerWidth >= 768;

    if (scrollTop >= headerScrollChangeAt && mediumPlus) {
      headerLogo.classList.add("scrolled-header-logo");
    } else {
      headerLogo.classList.remove("scrolled-header-logo");
    }
  };

  return (
    <Link to="/" className="w-32">
      <div className="header-logo flex items-center transition-all duration-1000 h-20 md:h-24 p-4 text-3xl ">
        <img
          src={`${process.env.PUBLIC_URL}/containx-logo-192.png`}
          alt="Logo"
          className="h-full mr-2"
        />
        <span className="font-bold text-logo ">ContainX</span>
      </div>
    </Link>
  );
};

export default Logo;
